import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Twitter, Phone, Mail, MapPin, Globe, Heart } from "lucide-react";
import { schoolInfo, navLinks } from "../../mock/mock";
import NewsletterForm from "./NewsletterForm";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-stone-900 via-orange-950 to-stone-900 text-white pt-16 pb-6 mt-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src={schoolInfo.logoUrl}
                alt="Aadi Gayanam Logo"
                className="w-14 h-14 rounded-full object-cover shadow-lg bg-white p-0.5"
              />
              <div>
                <h3 className="font-display font-bold text-xl leading-none">Aadi Gayanam</h3>
                <p className="text-xs text-amber-300 tracking-widest uppercase">Play School</p>
              </div>
            </div>
            <p className="text-stone-300 text-sm leading-relaxed mb-4">
              A unique play school by <span className="text-amber-300 font-medium">{schoolInfo.parentOrg}</span> committed to blending Sanatan values with modern learning for holistic child development.
            </p>
            <p className="font-devanagari text-lg text-amber-200 italic">{schoolInfo.sanskritMotto}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-display font-bold text-lg mb-4 text-amber-300">Quick Links</h4>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-stone-300 hover:text-amber-300 text-sm transition-colors flex items-center gap-2">
                    <span className="w-1.5 h-1.5 bg-orange-500 rounded-full" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-lg mb-4 text-amber-300">Get in Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5 text-sm text-stone-300">
                <MapPin className="w-4 h-4 text-orange-400 mt-0.5 flex-shrink-0" />
                <span>{schoolInfo.address}</span>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-stone-300">
                <Phone className="w-4 h-4 text-orange-400" />
                <a href={`tel:${schoolInfo.phone}`} className="hover:text-amber-300">{schoolInfo.phone}</a>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-stone-300">
                <Mail className="w-4 h-4 text-orange-400" />
                <a href={`mailto:${schoolInfo.email}`} className="hover:text-amber-300">{schoolInfo.email}</a>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-stone-300">
                <Globe className="w-4 h-4 text-orange-400" />
                <span>{schoolInfo.website}</span>
              </li>
            </ul>
          </div>

          {/* Newsletter & Social */}
          <div>
            <h4 className="font-display font-bold text-lg mb-4 text-amber-300">Stay Connected</h4>
            <p className="text-stone-300 text-sm mb-3">Get updates, activities and stories from our little ones.</p>
            <div className="mb-5">
              <NewsletterForm />
            </div>
            <div className="flex gap-2 mb-4">
              {[
                { icon: Facebook, href: schoolInfo.social.facebook },
                { icon: Instagram, href: schoolInfo.social.instagram },
                { icon: Youtube, href: schoolInfo.social.youtube },
                { icon: Twitter, href: schoolInfo.social.twitter }
              ].map((s, i) => (
                <a key={i} href={s.href} className="w-10 h-10 rounded-full bg-white/10 hover:bg-orange-600 flex items-center justify-center transition-colors">
                  <s.icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <Link to="/admission" className="inline-block px-5 py-2.5 bg-gradient-to-r from-orange-600 to-amber-600 rounded-full text-sm font-semibold hover:from-orange-700 hover:to-amber-700 transition-all shadow-lg">
              Apply for Admission
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-stone-400 text-xs">
            © {new Date().getFullYear()} Aadi Gayanam Play School by {schoolInfo.parentOrg}. All rights reserved.
          </p>
          <p className="text-stone-400 text-xs flex items-center gap-1.5">
            Made with <Heart className="w-3 h-3 text-red-500 fill-red-500" /> in Jaipur, Bharat
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
